import ProductIndexing from './ProductIndexing.vue';

export const productIndexingRoutes = [
  { path: 'product-indexing', component: ProductIndexing, name: 'product-indexing' }
];
